import React from "react";
import { ToastContainer, toast } from "react-toastify";
import { createUser } from "../../../../services/create-user.service";
import TopBarProgress from "react-topbar-progress-indicator";
import { Link } from "react-router-dom";
import CustomInput from "../../../../components/custom-input/custom-input";
import DropDownInput from "../../../../components/drop-down-input/drop-down-input";
import CustomButton, {
  CustomButtonClasses,
  CustomButtonTypes,
} from "../../../../components/custom-button/custom-button";
import HeadingSecondary from "../../../../components/custom-heading/heading-secondary";
import HeadingPrimary from "../../../../components/custom-heading/heading-primary";

TopBarProgress.config({
  barThickness: 4,
  barColors: {
    0: "rgb(51, 201, 45, .7)",
    ".3": "rgb(255, 77, 107, .7)",
    "1.0": "rgb(200, 125, 255, .7)",
  },
  shadowBlur: 5,
  shadowColor: "rgba(0, 0, 0, .5)",
});

const roles = [
  { value: "admin", label: "Admin" },
  { value: "user", label: "User" },
  { value: "techTeam", label: "TechTeam" },
  { value: "dataTeam", label: "DataTeam" },
  { value: "customerSupport", label: "CustomerSupport" },
  { value: "callCenter", label: "CallCenter" },
  { value: "marketing", label: "Marketing" },
  { value: "sales", label: "Sales" },
];

const CreateUser = () => {
  const [loading, setLoading] = React.useState(false);
  const [values, setValues] = React.useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "12345",
    role: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await createUser(values);
      toast.success(res.data.message, { containerId: "B" });
    } catch (err) {
      toast.error(err.data.message, { containerId: "B" });
    } finally {
      setLoading(false);
    }
  };

  const handleChangeRole = (e) => {
    setValues({
      ...values,
      role: e.value,
    });
  };

  return (
    <div className="container-scroller">
      {loading && <TopBarProgress />}

      <ToastContainer
      stacked 
        enableMultiContainer
        containerId={"B"}
        // position={toast.POSITION.TOP_RIGHT}
          position="top-right" // Hardcoded position
      />

      <div className="page-header">
        <HeadingPrimary styles={{ fontSize: 30 }}>Create User</HeadingPrimary>

        <div>
          <Link to="/admin/users">Users</Link>
          &nbsp; / Create User
        </div>
      </div>

      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div
            className="card p-0"
            style={{
              border: "1px solid #dcdcdc",
            }}
          >
            <div className="card-body p-0">
              <HeadingSecondary>Add a new main category</HeadingSecondary>

              <form className="forms-sample m-3">
                <CustomInput
                  label="First Name"
                  name="firstName"
                  type="text"
                  placeholder="First Name"
                  onChange={handleChange}
                  value={values.firstName}
                  labelStyles={{ fontWeight: "bold" }}
                />

                <CustomInput
                  label="Last Name"
                  name="lastName"
                  type="text"
                  placeholder="Last Name"
                  onChange={handleChange}
                  value={values.lastName}
                  labelStyles={{ fontWeight: "bold" }}
                />

                <CustomInput
                  label="Email"
                  name="email"
                  type="email"
                  placeholder="Email"
                  onChange={handleChange}
                  value={values.email}
                  labelStyles={{ fontWeight: "bold" }}
                />

                <CustomInput
                  label="Password"
                  name="password"
                  type="text"
                  placeholder="Password"
                  onChange={handleChange}
                  value={values.password}
                  labelStyles={{ fontWeight: "bold" }}
                />

                <DropDownInput
                  label="Role"
                  name="role"
                  onChange={handleChangeRole}
                  placeholder={"Please Select"}
                  options={roles}
                  value={values.role}
                  labelStyles={{ fontWeight: "bold" }}
                />

                <CustomButton
                  type={CustomButtonTypes.SUBMIT}
                  className={CustomButtonClasses.PRIMARY}
                  onClick={handleSubmit}
                >
                  Submit
                </CustomButton>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateUser;
